import { Component, OnInit, ViewChild, QueryList, ViewChildren, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DBOperation } from '../../../shared/enum';
import { Global, BaoCao } from '../../../shared/global';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Repository } from '../../../services/repository'
import { ActivatedRoute } from '@angular/router';
import 'jquery'
import 'bootstrap'
import { MaskedDateTimeService } from '@syncfusion/ej2-angular-calendars';
import { DomSanitizer } from '@angular/platform-browser';

import { DialogComponent, ButtonPropsModel, PositionDataModel, ResizeDirections } from '@syncfusion/ej2-angular-popups';
import { AnimationSettingsModel } from '@syncfusion/ej2-splitbuttons';

import {
  Lists_linhvuc, Lists_domat, Lists_dokhan
  , Lists_diadanh, Ultil_donvi,
  Lists_canbo,
  VanBanDens_NhapVanBanDen
  //HanhChinhs_congvanden, HanhChinhs_quyenthemdexuatcuaphong, HanhChinhs_quyenthemykienldc
  
} from '../../../routes/menu'
import { load } from '@telerik/kendo-intl';


const swal = require('sweetalert');
@Component({
  selector: 'app-vanban-congvanxulyedit',
  templateUrl: './congvanxulyedit.component.html',
  //templateUrl: 'Climport { log } from 'util';

  styleUrls: ['./congvanxulyedit.component.scss'],
  providers: [ListService, Repository]
})


export class congvanxulyeditComponent implements OnInit {


  @ViewChild('modalphoihop')
  public modalphoihop: DialogComponent;
  public position: PositionDataModel = { X: 'center', Y: 'top' };
  public resizeHandleDirection: ResizeDirections[] = ['All'];
  public dialogResize: Boolean = true;
  public dialogdragging: Boolean = true;


  public width: string = '1050px';
  //public height = '800';
  public animationSettings: AnimationSettingsModel = { effect: 'None' };
  public target: string = '.control-section';
  // On Dialog close, 'Open' Button will be shown
  public dialogClose = (): void => {
    this.modalphoihop.hide();
    //document.getElementById('dlgbtn').style.display = '';
  }
  // On Dialog open, 'Open' Button will be hidden
  public dialogOpen = (): void => {
   // document.getElementById('dlgbtn').style.display = 'none';
  }
  public dlgBtnClick = (): void => {
    this.modalphoihop.hide();
  }
  public dlgButtons: ButtonPropsModel[] = [{ click: this.dlgBtnClick.bind(this), buttonModel: { content: 'Đóng', isPrimary: true } }
  ];
  @ViewChild('ctdonviphoihopedit') ctdonviphoihopedit: any;
  

  han_qd: Date=null;
  VanBanSelected: any = { Anhs: [], chi_dao: null, QiaiQuyets: []};
  public format: string = "dd/M/yyyy";
  public enableMaskSupport: boolean = true;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public maxSize: number = 5;
  public DonViId: any;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TuNgay: Date;
  public DenNgay: Date;
  public tTuNgay: string;
  public tDenNgay: string;
  inputdokhans: any;
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;

  quyen_them_ykiencuadonvi: boolean = false;
  quyen_them_ykienlanhdaocuc: boolean = false;
   
  quyen_themdoituong: boolean = false;
  quyen_themlinhvuc: boolean = false;
  quyen_themdomat: boolean = false;
  quyen_themdokhan: boolean = false;
  quyen_themdonvi: boolean = false;
  quyen_themdonvingoai: boolean = false;
  inputphongbans: any;
  inputcanbos: any;
  datas: any;
  lichtuans: any;
  public ChuyenBoPhan: any = {
     DonViId: null
    , UserName: null
    , Ma_DV: null
    , Loai: 0
    , UserID: null
    , vanban_id: null
    , noi_chuyen: null
    , Quyen: null
    , cd: null
    , chu_tri: null
    , phoi_hop: null
    , de_biet: null
    , giai_quyet: null
    , Han_GQ: null
    , Han_GQS: null
    , tt: false
    , Tyle: null
    , chuyen_nham: null
    , do_khan: null
    , ket_thuc: false
    , loai: null
  };
  public TimKiems: any = {
    DonViId: null
    , UserName: null
    , TuNgay: null
    , DenNgay: null
    , PhanHeId: null
    , TimKiem: null
    , startPage: null
    , endPage: null
    , SoCongVan: null
    , TrichYeu: null
    , ChiDao: null
    , KyHieu: null
    , TenSo: null
    , NgayCV: null
    , NoiDung: null
    , CanBo: null
    , TrangThai: null

    , Ma_DV: null
    , Loai: 0
    , UserID: null
    ,NoiNhan: null

  };
  msg: string;
  //@ViewChild('modal', { static: false }) modal: ModalComponent;
 // @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
 // @ViewChild('mdCanBo', { static: false }) mdCanBo: ModalComponent;
  @ViewChildren(NgSelectComponent) slcombo: QueryList<NgSelectComponent>
  @ViewChild('dteChung') doituongchungedit: any;
  @ViewChild('dteCanBo') canboedit: any;

 // @ViewChild('modaldonviphoihop', { static: false }) modaldonviphoihop: ModalComponent;
  @ViewChild('dtdonviphoihop') dtdonviphoihop: any;

//  @ViewChild('modalBZDinhKem', { static: false }) modalBZDinhKem: ModalComponent;
  @ViewChild('dteBZDinhKem') dteBZDinhKem: any;

  //@ViewChild('modaldonvi', { static: false }) modaldonvi: ModalComponent;
  //@ViewChild('dtdonvi', { static: false }) dtdonvi: any;

 // @ViewChild('modalphucdapcongvan', { static: false }) modalphucdapcongvan: ModalComponent;
  @ViewChild('ctphucdapcongvanedit') ctphucdapcongvanedit: any;

//  @ViewChild('modaldonvi', { static: false }) modaldonvi: ModalComponent;
  @ViewChild('dtedonvi') dtedonvi: any;

  data: Idata;
  indLoading: boolean = false;
  hienthianh: boolean = false;
  file: any;
  tcongviec: any;
  dataFrm: FormGroup;
  dbops: DBOperation;
  modalTitle: string;
  modalBtnTitle: string;
  inputdonvis: any;
  inputlinhvucs: any;
  inputdomats: any;
  giaodienxuly: number;
  inputloaicongvans: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Hành chính" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Nghiệp vụ" }];
  inputstatuss: any = [{ Id: 0, Ma_Doi_Tuong: "0", Ten_Doi_Tuong: "Chờ chuyển đi" }
    , { Id: 1, Ma_Doi_Tuong: "1", Ten_Doi_Tuong: "Đã gửi và chờ tiếp nhận" }
    , { Id: 2, Ma_Doi_Tuong: "2", Ten_Doi_Tuong: "Đã tiếp nhận" }
    , { Id: 3, Ma_Doi_Tuong: "3", Ten_Doi_Tuong: "Gửi trả lại" }
    , { Id: 4, Ma_Doi_Tuong: "4", Ten_Doi_Tuong: "Kết thúc" }
    , { Id: 5, Ma_Doi_Tuong: "5", Ten_Doi_Tuong: "Đang xử lý" }
    , { Id: 6, Ma_Doi_Tuong: "6", Ten_Doi_Tuong: "Công văn chậm" }
  ];

  inputnoiguis;
  public ngayden: Date = new Date();
  public ngaycongvan: Date = new Date();
  ngayketthuc: Date = new Date();
  hanketthuc: Date = new Date();
  ngaybatdau: Date = new Date();
  taikhoanno: any = null;
  tendoituong: any = null;
  tabselected: number = 1;
  slquahan: number = 0;
  slsapquahan: number = 0;
  idnew: string;
  public mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() savect: EventEmitter<any> = new EventEmitter();
  phanheid: string = null;
  isHidden: number = 0;
  primaryColour: string = '#5d9cec';
  secondaryColour: string = '#ff902b';
  //----------tham số các nhóm cột------------------
  nhomlinhvucid: string = Lists_linhvuc.id;
  nhomdomatid: string = Lists_domat.id;
  nhomdokhanid: string = Lists_dokhan.id;

  inputloainghiepvus: any;
  
  //-----------------------------------------------------

  doituongSelect: any = {
    Id: null, Don_Vi_Id: null, MaCongVan: null, NgayDen: null, NgayDenS:null,
    Phan_He_Id: null, IDNoiGui: null, NguoiKy: null, IDCongVanDuocTraLoi: null, IDLinhVuc: null
    , NgayCongVan: null, NgayCongVanS: null, YKienChiDao: null, NoiDung: null
    , IDNguoiCapNhat: null, LoaiCongVan: null,
    CongVanDen: null, IDCongViec: null, Visible: null, IDLoaiHinhCongVan: null
    , IDDoMat: null, IDDoKhan: null, IDChuyenToi: null,
    NgayKetThuc: null, NgayKetThucS: null, HanKetThuc: null
    , HanKetThucS: null, Status: null, SoDuocCap: null, DaXacNhan: null
    , SoCongVanThuc: null, Thu_Tu:null
    , AnhString: null, XoaAnh: null, TenCongViec: null, IdNew: null, LoaiNghiepVu: null
    , YKienChiDaoP1: null, DonViDieuPhoiId: null, LanhDaoId: null, DonVis: []
    , NN_ChiDao: null, NN_ChuTri: null, NN_PhoiHop: null, NN_DeBiet: null
    //ChiTiets: [], DongThois:[]
  };
  idFocus: string = '00000000-0000-0000-0000-000000000000';

  public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };
  public ngxAmOptions = { 
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: true
  };

  public currentUser;
  donviid: string = null;
  namketoan: number;
  username: string = null;
  transformYourHtml(htmlTextWithStyle) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlTextWithStyle);
  }

  savept(doituong: any) {
    let chidao = "";
    let chutri = "";
    let phoihop = "";
    let debiet = "";
    if (doituong != 'undefined') {
      doituong.forEach((item: any) => {
        if (item.ChiDao == true) {
          if (chidao == "")
            chidao = item.ID_Ten;
          else {
            if (chidao.indexOf(item.ID_Ten) < 0)
              chidao = chidao + ";" + item.ID_Ten;
          }
        }
        if (item.ChuTri == true) {
          if (chutri == "")
            chutri = item.ID_Ten;
          else {
            if (chutri.indexOf(item.ID_Ten) < 0)
            chutri = chutri + ";" + item.ID_Ten;
          }
        }
        if (item.PhoiHop == true) {
          if (phoihop == "")
            phoihop = item.ID_Ten;
          else {
            if (phoihop.indexOf(item.ID_Ten) < 0)
            phoihop = phoihop + ";" + item.ID_Ten;
          }
        }
        if (item.Xem == true) {
          if (debiet == "")
            debiet = item.ID_Ten;
          else {
            if (debiet.indexOf(item.ID_Ten) < 0)
            debiet = debiet + ";" + item.ID_Ten;
          }
        }
        if (item.children != null) {
          item.children.forEach((item1: any) => {
            if (item1.ChiDao == true) {
              if (chidao == "")
                chidao = item1.ID_Ten;
              else {
                if (chidao.indexOf(item1.ID_Ten) < 0)
                chidao = chidao + ";" + item1.ID_Ten;
              }
            }
            if (item1.ChuTri == true) {
              if (chutri == "")
                chutri = item1.ID_Ten;
              else {
                if (chutri.indexOf(item1.ID_Ten) < 0)
                chutri = chutri + ";" + item1.ID_Ten;
              }
            }
            if (item1.PhoiHop == true) {
              if (phoihop == "")
                phoihop = item1.ID_Ten;
              else {
                if (phoihop.indexOf(item1.ID_Ten) < 0)
                phoihop = phoihop + ";" + item1.ID_Ten;
              }
            }
            if (item1.Xem == true) {
              if (debiet == "")
                debiet = item1.ID_Ten;
              else {
                if (debiet.indexOf(item1.ID_Ten) < 0)
                debiet = debiet + ";" + item1.ID_Ten;
              }
            }
            if (item1.children != null) {
              item1.children.forEach((item2: any) => {
                if (item2.ChiDao == true) {
                  if (chidao == "")
                    chidao = item2.ID_Ten;
                  else {
                    if (chidao.indexOf(item2.ID_Ten) < 0)
                    chidao = chidao + ";" + item2.ID_Ten;
                  }
                }
                if (item2.ChuTri == true) {
                  if (chutri == "")
                    chutri = item2.ID_Ten;
                  else {
                    if (chutri.indexOf(item2.ID_Ten) < 0)
                    chutri = chutri + ";" + item2.ID_Ten;
                  }
                }
                if (item2.PhoiHop == true) {
                  if (phoihop == "")
                    phoihop = item2.ID_Ten;
                  else {
                    if (phoihop.indexOf(item2.ID_Ten) < 0)
                    phoihop = phoihop + ";" + item2.ID_Ten;
                  }
                }
                if (item2.Xem == true) {
                  if (debiet == "")
                    debiet = item2.ID_Ten;
                  else {
                    if (debiet.indexOf(item2.ID_Ten) < 0)
                    debiet = debiet + ";" + item2.ID_Ten;
                  }
                }
                item2.children.forEach((item3: any) => {
                  if (item3.ChiDao == true) {
                    if (chidao == "")
                      chidao = item3.ID_Ten;
                    else {
                      if (chidao.indexOf(item3.ID_Ten) < 0)
                      chidao = chidao + ";" + item3.ID_Ten;
                    }
                  }
                  if (item3.ChuTri == true) {
                    if (chutri == "")
                      chutri = item3.ID_Ten;
                    else {
                      if (chutri.indexOf(item3.ID_Ten) < 0)
                      chutri = chutri + ";" + item3.ID_Ten;
                    }
                  }
                  if (item3.PhoiHop == true) {
                    if (phoihop == "")
                      phoihop = item3.ID_Ten;
                    else {
                      if (phoihop.indexOf(item3.ID_Ten) < 0)
                      phoihop = phoihop + ";" + item3.ID_Ten;
                    }
                  }
                  if (item3.Xem == true) {
                    if (debiet == "")
                      debiet = item3.ID_Ten;
                    else {
                      if (debiet.indexOf(item3.ID_Ten) < 0)
                      debiet = debiet + ";" + item3.ID_Ten;
                    }
                  }
                });
              });
            }

          });
        }
      });

      this.doituongSelect.NN_ChiDao = chidao;
      this.doituongSelect.NN_ChuTri = chutri;
      this.doituongSelect.NN_PhoiHop = phoihop;
      this.doituongSelect.NN_DeBiet = debiet;
      this.ChuyenBoPhan.cd = chidao;
      this.ChuyenBoPhan.chu_tri = chutri;
      this.ChuyenBoPhan.phoi_hop = phoihop;
      this.ChuyenBoPhan.de_biet = debiet;
    }
    this.modalphoihop.hide();
  }
  chondonvi(id: string) {
    this.ctdonviphoihopedit.loadDataInit(id, this.phanheid, null, this.doituongSelect);
    this.modalphoihop.show();
  }

  //savept(doituong: any) {
  //  this.modalphoihop.hide();
  //}
  //chondonvi(id: string) {
  //  this.ctdonviphoihopedit.loadDataInit(id, this.phanheid, null);
  //  this.modalphoihop.show();
  //}
  public changeKT() {
    if (this.ChuyenBoPhan.ket_thuc == true)
      this.ChuyenBoPhan.Tyle = 100;
    else
      this.ChuyenBoPhan.Tyle = 0;
  }
  Loaddatas(tselect: any) {
    this.selectedRow = null;
    this.ChuyenBoPhan.vanban_id = null;
    this.doituongSelect.NN_ChiDao = null;
    this.doituongSelect.NN_ChuTri = null;
    this.doituongSelect.NN_PhoiHop = null;
    this.doituongSelect.NN_DeBiet = null;
    this.ChuyenBoPhan = {
      DonViId: this.donviid
      , UserName: this.username
      , Ma_DV: this.currentUser.ma_dv
      , Loai: 0
      , UserID: this.currentUser.userid
      , vanban_id: null
      , noi_chuyen: null
      , Quyen: null
      , cd: null
      , chu_tri: null
      , phoi_hop: null
      , de_biet: null
      , giai_quyet: null
      , Han_GQ: null
      , Han_GQS: null
      , tt: false
      , Tyle: null
      , chuyen_nham: null
      , do_khan: null
      , ket_thuc: false
      , loai: null
    };
    if (this.TuNgay != null) {
      this.tTuNgay = this.TuNgay.getDate() + '/' + (this.TuNgay.getMonth() + 1) + '/' + this.TuNgay.getFullYear();
    }
    if (this.DenNgay != null) {
      this.tDenNgay = this.DenNgay.getDate() + '/' + (this.DenNgay.getMonth() + 1) + '/' + this.DenNgay.getFullYear();
    }
    this.indLoading = true;
    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiems.DonViId = this.currentUser.id_don_vi;
    this.TimKiems.UserName = this.currentUser.user_name;
    this.TimKiems.Ma_DV = this.currentUser.ma_dv;
    this.TimKiems.TuNgay = this.tTuNgay;
    this.TimKiems.DenNgay = this.tDenNgay;
    this.TimKiems.PhanHeId = this.phanheid;
    //this.TimKiems.TimKiem = this.TimKiem;
    this.TimKiems.startPage = this.StartPage;
    this.TimKiems.endPage = this.EndPage;
    this.TimKiems.Loai = 0;
    if (this.tabselected == 1)
      this.TimKiems.Loai = 0;
    if (this.tabselected == 2)
      this.TimKiems.Loai = 1;
    if (this.tabselected == 3)
      this.TimKiems.Loai = 2;
    if (this.tabselected == 4)
      this.TimKiems.Loai = 4;

    this.TimKiems.UserID = this.currentUser.userid;
    if (this.lacaptren == 2)
      this.TimKiems.Noi_Nhan = this.currentUser.captrenid;
    else
      this.TimKiems.Noi_Nhan = this.currentUser.userid;

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.TimKiems)
    };

    if (tselect == 1)
      $('#loading').show();

    this.repo.postRequest("api/congvan/VanBanDen_GetDS/", data)
      .subscribe(response => {
        if (tselect == 1)
          $('#loading').hide();
        //console.log(response);
        this.totalPages = 0;
        this.totalItems = 0;
        if (response.length > 0) {

          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);

          this.slquahan = item["QuaHan"];
          this.slsapquahan = item["SapQuaHan"];


          let start, end;

          if (this.totalPages <= 3) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 2) {
              start = 1;
              end = 3;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 2;
              end = this.totalPages;
            } else {
              start = this.currentPage - 1;
              end = this.currentPage + 1;
            }
          }



          // this.pages = range(start, end + 1);
          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
            //alert(i);
          }
          this.pages = resultArray;

          console.log(start);
          console.log(end);

          console.log(item);

        }
        this.datas = response;
        // this.source.load(response);
      });
  }

  //-----------------cac hàm khởi tạo dữ liệu ban đầu
  constructor(private route: ActivatedRoute, private fb: FormBuilder, private _dataService: ListService, private repo: Repository, private sanitizer: DomSanitizer) {

      this.route.data.subscribe(v => { this.phanheid = v.func, this.lacaptren = v.loai });

    this.repo.postRequest('api/congvan/domat_dokhan', { Loai:3 })
      .subscribe(response => {
        this.inputdokhans = response;
      });
     
  }
  NewGuid() {
    var guid;
    guid = ((((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
      + "-" + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) + "-4" + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1).substr(0, 3) + "-" +
      (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) + "-" + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
      + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1) + (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)).toLowerCase();
    this.idnew = guid;
  }
 // @HostListener('document:keydown', ['$event'])
  //public innerHeight: any
  //id--ichung tu; loai: đánh dấu trường hợp copy (1: copy, 0: ko),pheid: phanheid,ctu: chung tu rut du toan
  themmoi: number = 0;
  lacaptren: number;
  loadDataInit(id: string, loai: number, pheid: string, congviec: any) {
    this.lacaptren = loai;
    this.tcongviec = congviec;
    //this.innerHeight = window.innerHeight - 250;
    if (congviec != null) {
     // duoc goi tu giao dien danh sach cong viec van thu
      this.giaodienxuly = congviec.GiaoDienXuLy;
    }
    this.NewGuid();
    this.ngayden = new Date();
    this.ngaycongvan = new Date();
    this.ngayketthuc = new Date();
    this.hanketthuc = new Date();
    this.tabselected = 1;
    this.phanheid = pheid;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
    this.donviid = this.currentUser.id_don_vi;
    this.namketoan = this.currentUser.nam_ke_toan;
    this.username = this.currentUser.user_name;
    var giatri = this.currentUser.ds_quyen.filter(name => name.Id === this.phanheid.toLowerCase());
    if (giatri != null && giatri.length > 0) {
      if (giatri[0].Them == true)
        this.quyen_them = true;
      else
        this.quyen_them = false;
      if (giatri[0].sua == true)
        this.quyen_sua = true;
      else
        this.quyen_sua = false;
      if (giatri[0].xoa == true)
        this.quyen_xoa = true;
      else
        this.quyen_xoa = false;
    }

  }
    // gán quyền thêm đối tượng
    var giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === ('532A61EA-D765-844B-8CBF-E610B209E332').toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themdoituong = true;
      else
        this.quyen_themdoituong = false;
    }
    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === Lists_linhvuc.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themlinhvuc = true;
      else
        this.quyen_themlinhvuc = false;
    }
    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === Lists_domat.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themdomat = true;
      else
        this.quyen_themdomat = false;
    }
    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === Lists_dokhan.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themdokhan = true;
      else
        this.quyen_themdokhan = false;
    }
    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === Lists_diadanh.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themdonvi = true;
      else
        this.quyen_themdonvi = false;
    }
    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === Ultil_donvi.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_themdonvingoai = true;
      else
        this.quyen_themdonvingoai = false;
    }

    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === VanBanDens_NhapVanBanDen.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_them_ykiencuadonvi = true;
      else
        this.quyen_them_ykiencuadonvi = false;
    }

    giatri1 = this.currentUser.ds_quyen.filter(name => name.Id === VanBanDens_NhapVanBanDen.id.toLowerCase());
    if (giatri1 != null && giatri1.length > 0) {
      if (giatri1[0].Them == true)
        this.quyen_them_ykienlanhdaocuc = true;
      else
        this.quyen_them_ykienlanhdaocuc = false;
    }
  
  
      this.doituongSelect = {
        Id: null, Don_Vi_Id: null, MaCongVan: null, NgayDen: null, NgayDenS: null,
        Phan_He_Id: null, IDNoiGui: null, NguoiKy: null, IDCongVanDuocTraLoi: null, IDLinhVuc: null
        , NgayCongVan: null, NgayCongVanS: null, YKienChiDao: null, NoiDung: null
        , IDNguoiCapNhat: null, LoaiCongVan: null,
        CongVanDen: null, IDCongViec: null, Visible: null, IDLoaiHinhCongVan: null
        , IDDoMat: null, IDDoKhan: null, IDChuyenToi: null,
        NgayKetThuc: null, NgayKetThucS: null, HanKetThuc: null
        , HanKetThucS: null, Status: null, SoDuocCap: null, DaXacNhan: null
        , SoCongVanThuc: null, Thu_Tu: null
        , AnhString: null, XoaAnh: null, TenCongViec: null, IdNew: null, LoaiNghiepVu: null
        , YKienChiDaoP1: null, DonViDieuPhoiId: null, LanhDaoId: null, DonVis: []
        , NN_ChiDao: null, NN_ChuTri: null, NN_PhoiHop: null, NN_DeBiet: null
        //ChiTiets: [], DongThois:[]
      };
    this.doituongSelect.AnhString = null;
    this.hienthianh = false;
    $('#blah').attr('src', "/assets/img/anhdt.gif");
    //this.file = [];
   

    if (id === null) {
      this.themmoi = 1;
      this.doituongSelect.Status = 5;
      this.doituongSelect.IdNew = this.idnew;
      this.doituongSelect.DonViDieuPhoiId = ('A6CAA0A9-FB8C-4F5C-A679-06D17FAE496A').toLowerCase();
      console.log(this.isHidden);
      this.doituongSelect.Phan_He_Id = this.phanheid;
      if (congviec != null) {
        this.doituongSelect.TenCongViec = congviec.TenCongViec;
        this.doituongSelect.NgayBatDau = congviec.NgayLap;
        this.doituongSelect.NgayKetThuc = congviec.NgayKetThuc;
        if (this.doituongSelect.NgayKetThuc != null)
          this.ngayketthuc = new Date(this.doituongSelect.NgayKetThuc);
        if (this.doituongSelect.NgayBatDau != null)
          this.ngaybatdau = new Date(this.doituongSelect.NgayBatDau);
      }
      //this.repo.getRequest("api/congvan/laymacongvan/", { id: this.idnew })
      //  .subscribe(response => {
      //    this.doituongSelect.MaCongVan = response;
      //  });

      this.doituongSelect.LoaiCongVan = 0;

    }
    else {
     
      //this.repo.getRequest("api/congvan/getbyid/", { id: id })
      //  .subscribe(response => {
      //    if (response != null) {
      //      this.doituongSelect = response;
      //      this.doituongSelect.IdNew = id;
      //      if (this.doituongSelect.NgayDen != null)
      //        this.ngayden = new Date(this.doituongSelect.NgayDen);
      //      if (this.doituongSelect.NgayCongVan != null)
      //        this.ngaycongvan = new Date(this.doituongSelect.NgayCongVan);
      //      if (this.doituongSelect.NgayKetThuc != null)
      //        this.ngayketthuc = new Date(this.doituongSelect.NgayKetThuc);
      //      if (this.doituongSelect.HanKetThuc != null)
      //        this.hanketthuc = new Date(this.doituongSelect.HanKetThuc);

      //      if (this.doituongSelect.AnhString != null)
      //        this.hienthianh = true;
           
      //      if (congviec != null) {
      //        this.doituongSelect.IDCongViec = congviec.Id;
      //      }

      //      this.repo.postRequest('api/doituong/dsdoituonglinhvuc', { NhomId: Lists_linhvuc.id, MaGiaoDien: '', DonViId: this.donviid, Loai: response.LoaiCongVan })
      //        .subscribe(response => {
      //          this.inputlinhvucs = response;
      //        });


      //    }


      //  });
      


    }


    this.Loaddatas(0);
    //this.repo.getRequest("api/congvan/getdonviphoihop/" + id)
    //  .subscribe(response => {
    //    this.doituongSelect.DonVis = response.DonVis;
    //  }); 

    console.log(this.isHidden);

      setTimeout(() => {
       // this.slKhachHang.focus();
      }, 1000);
  }
  
  tId: any;
  selectedRow: any;
  selected(row: any) {
    this.tId = row.Id;
    this.ChuyenBoPhan.vanban_id = this.tId;
    this.ChuyenBoPhan.loai = row.loai;
    this.selectedRow = row;



    
    
    this.TimKiems.Loai = 0;
    if (this.tabselected == 1)
      this.TimKiems.Loai = 0;
    if (this.tabselected == 2)
      this.TimKiems.Loai = 1;
    if (this.tabselected == 3)
      this.TimKiems.Loai = 2;
    if (this.tabselected == 4)
      this.TimKiems.Loai = 4;

    if (this.lacaptren == 2)
      this.TimKiems.Noi_Nhan = this.currentUser.captrenid;
    else
      this.TimKiems.Noi_Nhan = this.currentUser.userid;

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , Ma_DV: this.currentUser.ma_dv
        , PhanHeId: this.phanheid
        , Loai: this.TimKiems.Loai
        , UserID: this.currentUser.userid
        , Noi_Nhan: this.TimKiems.Noi_Nhan
        , Id: row.Id
        , da_doc: row.da_doc
        , PB_ID_Or: this.currentUser.pb_id
       
      })
    };
    this.repo.postRequest('api/congvan/GetFile', data)
      .subscribe(response => {
        this.VanBanSelected = response;
      });

  }
  openFiles_html(file: any) {
    file = "FileTaiLieu/" + file;
    console.log("file");
    console.log(file);
    window.open(file, "_blank");
  }  
  selectTab(tab: number) {
    // $('#loading').show();
    this.tabselected = tab;
    this.Loaddatas(1);
    //$('#loading').hide();
  }
  pageChanged(event: any): void {
    // alert(event.page);
    //console.log('a');
    //console.log(event);
    this.currentPage = event.page;
    this.Loaddatas(0);
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }

    this.currentPage = page;
    this.Loaddatas(0);
  }
  search() {
    this.currentPage = 1;
    this.pageSize = 20;
    this.Loaddatas(0);
  }
  search1() {
    this.Loaddatas(0);
  }
  selectRow(row: any) {
    
  }
 

  ngOnInit(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.donviid = this.currentUser.id_don_vi;
      this.namketoan = this.currentUser.nam_ke_toan;
      this.username = this.currentUser.user_name;
    }
    this.LoadCategory();

    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , Ma_DV: this.currentUser.ma_dv
        , PhanHeId: this.phanheid
        , Loai: this.TimKiems.Loai
        , UserID: this.currentUser.userid
        , PB_ID_Or: this.currentUser.pb_id

      })
    };
    this.repo.postRequest('api/congvan/GetLichTuan', data)
      .subscribe(response => {
        this.lichtuans = response;
      });


    this.Loaddatas(1);
   
  }
  Tai_Anh() {

    this.doituongSelect.XoaAnh = 1;
    $("#File").click();
  }
  Xoa_Anh() {

    this.doituongSelect.XoaAnh = 0;
    $('#blah').attr('src', "/assets/img/anhdt.gif");
  }
  getFiles(event) {
    this.file = event.target.files;
    if (!this.file[0].type.match("image.*")) {
      alert("Tệp chọn không phải kiểu ảnh.");
      event.srcElement.value = null;
      return;
    }

    var reader = new FileReader();
    reader.onload = this._handleReaderLoaded.bind(this);
    reader.readAsBinaryString(this.file[0]);
    
  }
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.doituongSelect.AnhString = btoa(binaryString);  // Converting binary string data. 
    $('#blah').attr('src', "data:image/png;base64," + this.doituongSelect.AnhString + "");
    
  }
  LoadCategory(): void {
  
    //      this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2',{NhomId:Lists_domat.id,MaGiaoDien:'',DonViId:this.donviid})
    //        .subscribe(response => {
    //            this.inputdomats = response;
    //  }); 
    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: null, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputloainghiepvus = response;
    //  });

    //this.repo.postRequest('api/doituong/dsdoituongkethuatheodoituongidv2', { NhomId: Lists_dokhan.id, MaGiaoDien: '', DonViId: this.donviid })
    //  .subscribe(response => {
    //    this.inputdokhans = response;
    //  });

    //this.repo.getRequest('api/phongban/getdm2')
    //  .subscribe(response => {
    //    this.inputphongbans = response;
    //  });

    //this.repo.postRequest('api/doituong/dslanhdao', { NhomId: Lists_canbo.id, MaGiaoDien: '', DonViId: this.donviid, Code: 'DSLANHDAO' })
    //  .subscribe(response => {
    //    this.inputcanbos = response;
    //  });

    //      this.repo.postRequest('api/doituong/dsdoituonglinhvuc', { NhomId: Lists_linhvuc.id, MaGiaoDien: '', DonViId: this.donviid })
    //          .subscribe(response => {
    //            this.inputlinhvucs = response;
    //         });
    //      this.repo.getRequest("api/donvi/getall/")
    //        .subscribe(response => {
    //          this.inputnoiguis = response;
    //        });
    }
    
 @ViewChildren("myinput") divs: QueryList<ElementRef>;  

    //----------event xử lý di chuyển Enter--------------------------------------
  tongtien: number = 0;
  
  maxcot:number = 13;
  
  
  onDoiTuongLoaiCongVanChange($event) {
    //let loai = 0;
    //if (this.doituongSelect.LoaiCongVan == 1)
    //  loai = 0;
    //if (this.doituongSelect.LoaiCongVan == 0)
    //  loai = 1;
    this.doituongSelect.IDLinhVuc = null;
    this.doituongSelect.LoaiNghiepVu = null;
    this.repo.postRequest('api/doituong/dsdoituonglinhvuc', { NhomId: Lists_linhvuc.id, MaGiaoDien: '', DonViId: this.donviid, Loai: this.doituongSelect.LoaiCongVan })
      .subscribe(response => {
        this.inputlinhvucs = response;
      });
  }
   
    onDoiTuongChange($event) {
      
      //if (typeof $event === "undefined") {
      //  this.doituongSelect.Ho_Ten = null;
      //}
      //else {
      //  this.doituongSelect.Ho_Ten = $event.Ten_Doi_Tuong;

      //  this.doituongSelect.ChiTiets.forEach(
      //    (item) => {
      //      if (item.Doi_Tuong_Id2 === null)
      //        item.Doi_Tuong_Id2 = $event.Id;
      //    }
      //  );

      //  this.repo.getRequest("api/baselayout/ThongTinDiaChi/" + $event.Id)
      //    .subscribe(response => {
      //      //console.log(response);
      //      this.doituongSelect.Dia_Chi = response.Dia_Chi;
            
      //    });
      //}
    }
    
    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma_Don_Vi.toLowerCase().indexOf(term) > -1 || item.Ten_Don_Vi.toLowerCase().indexOf(term) > -1;
  }
    rowSelected: any = null;
    comboSeleted: NgSelectComponent;

    //AddNguoiNop(cobo: NgSelectComponent) {
    //  this.doituongchungedit.loadDataInit(cobo.addTagText, null, this.donviid);
    //  this.mdDoiTuongChung.open();
    //}
 
    AddNguoiNop(cobo:NgSelectComponent)
    {
      this.doituongchungedit.loadDataInit(cobo.addTagText, null, this.donviid);
     // this.mdDoiTuongChung.open();
    }
    loaithem:number = 2;
    onLoaiNguoiNop(loai:number)
    {
        this.loaithem = loai;
        console.log(loai);
    }
   
    //------------------------------------
  
  saveModalCanBo(doituong: any) {    
     // this.mdCanBo.dismiss();
    this.inputlinhvucs.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
    this.inputlinhvucs = this.inputlinhvucs.slice();

    this.doituongSelect.Doi_Tuong_Id = doituong.Id;
    this.tendoituong = doituong.Ten_Doi_Tuong;      
  }
  saveModalDV(doituong: any) {
   // this.modaldonviphoihop.dismiss();
  }

    saveModal(doituong:any){        
        console.log(doituong);        
     // this.mdDoiTuongChung.dismiss();
      
      //if (doituong != null && Lists_doituongtaphop.id === doituong.Nhom_Doi_Tuong_ID) {
      //  this.inputtaphops.push({ Id: doituong.Id, Ma_Doi_Tuong: doituong.Ma_Doi_Tuong, Ten_Doi_Tuong: doituong.Ten_Doi_Tuong })
      //  this.inputtaphops = this.inputtaphops.slice();

      //  this.rowSelected.Doi_Tuong_Id_5 = doituong.Id;
      //}
       this.comboSeleted.focus();
  }
  deleterow(index: string, luoi: number) {
    console.log(index);
    swal({
      title: 'Bạn muốn xóa dòng này phải không?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          if(luoi === 3)
            this.doituongSelect.DongThois.splice(index, 1);
          else
            this.doituongSelect.ChiTiets.splice(index, 1);

         
        }
      });


  }
  public donviphoihop() {
    
    this.dtdonviphoihop.loadDataInit(this.phanheid, this.doituongSelect.Id, this.donviid);
    //this.modaldonviphoihop.open();
  }
  public savectu(loai: number) {


    
    //if (this.doituongSelect.SoCongVanThuc === null || this.doituongSelect.SoCongVanThuc === '') {
    //  swal('Cảnh báo!', "Bạn chưa nhập số cv gốc", 'warning');
    //  return;
    //}
   
   

    if (this.ChuyenBoPhan.Han_GQ != null)
      this.ChuyenBoPhan.Han_GQS = this.ChuyenBoPhan.Han_GQ.getDate() + '/' + (this.ChuyenBoPhan.Han_GQ.getMonth() + 1) + '/' + this.ChuyenBoPhan.Han_GQ.getFullYear() + '/' + this.ChuyenBoPhan.Han_GQ.getHours() + '/' + this.ChuyenBoPhan.Han_GQ.getMinutes();
    else
      this.ChuyenBoPhan.Han_GQS = null;
    
    let data = {
      Id: null,
      Type: null,
      Data: JSON.stringify(this.ChuyenBoPhan)
    };

    $('#loading').show();
    this.repo.postRequest("api/congvan/Insert_ChuyenBoPhan", data)
      .subscribe(response => {
        $('#loading').hide();
        if (response === "1") {
          this.ChuyenBoPhan.noi_chuyen = null;
          this.ChuyenBoPhan.cd = null;
          this.ChuyenBoPhan.chu_tri = null;
          this.ChuyenBoPhan.phoi_hop = null;
          this.ChuyenBoPhan.de_biet = null;
          this.ChuyenBoPhan.giai_quyet = null;
          this.ChuyenBoPhan.Han_GQ = null;
          this.ChuyenBoPhan.Han_GQS = null;
          this.ChuyenBoPhan.tt = false;
          this.ChuyenBoPhan.Tyle = null;
          this.ChuyenBoPhan.chuyen_nham = null;
          this.ChuyenBoPhan.do_khan = null;
          this.ChuyenBoPhan.ket_thuc = false;
          //this.ChuyenBoPhan.loai = null;
          this.selected(this.selectedRow);
         }
        else
          swal('Cảnh báo!', response, 'warning');
      }); 

  }
  guilaitonghop() {
    swal({
      title: 'Bạn muốn gửi lại tổng hợp phải không?',
      text: 'Công văn sẽ được chuyển lại tổng hợp!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          let data = {
            Id: null,
            Type: null,
            Data: JSON.stringify({
              Id: this.doituongSelect.Id, IDCongVan: this.doituongSelect.Id
            })
          };
          this.repo.postRequest("api/congvan/guilaitonghop/", data)
            .subscribe(response => {
              swal('Thành công!', 'Hoàn thành!.', 'success');
            });

        }
      });


  }
  saveBienPhapNV(doituong: any) {
    ///this.modalphucdapcongvan.close();
  }
  phucdapcongvan() {
    if (this.doituongSelect.IDNoiGui == null || this.doituongSelect.IDNoiGui.length == 0) {
      swal('Cảnh báo!', "Bạn chưa có thông tin nơi gửi", 'warning');
      return;
    }
    else {
      //this.ctphucdapcongvanedit.loadDataInit(this.doituongSelect.Id, 0, HanhChinhs_congvanden.id, this.doituongSelect, null);
      //this.modalphucdapcongvan.open();
    }
  }
  closeModal() {
    this.save.emit(null);
    //if (this.tcongviec == null)
    //  this.save.emit(null);
    //else
    //  this.savect.emit(null);
  }
  saveDonVi(doituong: any) {
    if (doituong != null) {
      this.repo.getRequest("api/donvi/getall/")
        .subscribe(response => {
          this.inputnoiguis = response;
          this.doituongSelect.IDNoiGui = doituong.Id;
        });
    }
    //this.modaldonvi.close();
  }
  addDonVi() {

    this.modalTitle = "Thêm mới đơn vị";
    this.modalBtnTitle = "Thêm";
    this.dtedonvi.loadDataInit(Ultil_donvi.id, null, this.donviid);
    //this.modaldonvi.open();
  }
  bzdinhkem() {

    this.modalTitle = "Đính kèm";
    this.modalBtnTitle = "Cập nhật";
    let ttphanheid = null;
    this.dteBZDinhKem.loadDataInit(this.doituongSelect.IdNew, this.phanheid);
   // this.modalBZDinhKem.open();
  }
  savedk(dt: any) {
    //this.modalBZDinhKem.dismiss();
  }

  export(kieuin, loaiphieu) {
    //loaiphieu=1 là in phiếu thu
    //loaiphieu=2 là in phiếu chi
    //loaiphieu=3 là nhập kho
    //loaiphieu=4 là xuất kho
    //loaiphieu=5 là chứng từ kế toán
    //loaiphieu=6 là hóa đơn bán hàng
    //loaiphieu=7 là biên lại thu tiền
    //loaiphieu=8 là giấy đề nghị thanh toán
    //loaiphieu=9 là bảng kê đề nghị thanh toán

    //if (loaiphieu == null || loaiphieu == "") {
    //  swal('Cảnh báo!', 'Chưa chọn loại phiếu để in!.', 'warning');
    //  return;
    //}


    $('#loading').show();
    let data = {
      Id: 'A349FA0C-B091-4105-9A81-E0988CFF7571',
      Type: kieuin,
      Data: JSON.stringify({
        DonViId: this.currentUser.id_don_vi
        , UserName: this.currentUser.user_name
        , Id: this.doituongSelect.Id
        , LoaiPhieu: loaiphieu

      })
    };
    if (kieuin === 'xlsx') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          var file = new Blob([response.body], { type: 'vnd.ms-excel' });
          var fileURL = URL.createObjectURL(file);
          $('#loading').hide();
          var a = document.createElement("a");
          a.href = fileURL;
          a.download = "thong_tin_chi_tiet.xlsx";
          document.body.appendChild(a);
          a.click();

        });
    }
    if (kieuin === 'pdf') {
      this.repo.postPdf(Global.BASE_BaoCao_SAVE, data)
        .subscribe(response => {
          if (response == "L") {
            this.repo.postRequest(Global.BASE_BaoCao_SAVE, data).subscribe(
              data => {
                $('#loading').hide();
              },
              error => {
                this.msg = error;
              }
            );
          }
          else {
            $('#loading').hide();
            var file = new Blob([response.body], { type: 'application/pdf' });
            var fileURL = URL.createObjectURL(file);
            window.open(fileURL, "EPrescription");
          }

        });
    }

  }

}
export interface Idata {
    Id: string,  
    Ten: string,
    Dien_Thoai: string,
    Dia_Chi: string,
    Email: string,
    GhiChu:string,
    Created: Date,
    CreatedBy: string,
    Modified: Date,
    ModifiedBy:string
}
